<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h4 qid="p-view-page-title" class="mb-3">
              {{ incident.name }}
            </h4>
            <div class="mb-2">
              <span v-if="getGuide('update_basic_info')">
                <GuideButton :guide="getGuide('update_basic_info')"></GuideButton>
              </span>
            </div>
            <span v-if="incident.type" class="mr-2 ml-2">
              {{ $t('table.type') }}:
            </span>
            <span class="mr-1" v-if="incident.type">
              <span class="badge mb-1">
                {{ $t('maintenance.incidents.incident_categories.type.' + $options.filters.slugify(incident.type)) }}
              </span>
            </span>

          </div>

          <div class="col-md-6 text-right" qid="view-p-modified">
            <div class="mb-4">
                <span class="h6 ml-3">
                <span v-if="isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident.created_by) && (!getClient.parent || (getClient.parent && incident.partition))"
                      class="btn btn-edit"
                      qid="edit-p-button"
                      @click="showEditPModal(incident)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span v-if="isGranted([permissions.INCIDENT_CATEGORY_DELETE, permissions.INCIDENT_CATEGORY_DELETE_OWN], incident.created_by) && (!getClient.parent || (getClient.parent && incident.partition))"
                      class="btn btn-delete"
                      qid="delete-p-button"
                      @click="showConfirmDeleteModal(incident)"
                >
                  <font-awesome-icon icon="trash-alt"/>
                </span>
              </span>
            </div>
            <div>
              <span>{{ $t('table.last_updated') }}</span>
              <span class="ml-2 text-muted small" qid="view-p-modified-date">
                {{ incident.updated_at | formatDate }}
              </span>
              <Avatar v-if="incident.updated_by" :object="incident.updated_by" size="xs" class="ml-3 mr-2"></Avatar>
              <span v-if="incident.updated_by" qid="view-p-modified-by">
                {{ incident.updated_by.name }}
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <b-tabs class="mt-3">

      <!-- First tab -->
      <b-tab :title="$t('maintenance.incidents.incident_categories.tab.basic_info')" active>
        <div class="card mt-3">
          <!-- Update description -->
          <DescriptionBlock :object="incident" @updated="updateIncident"></DescriptionBlock>
        </div>
        <div class="card mt-3">
          <!-- Update description -->
          <IncidentSettings :object="incident" @updated="updateIncident"></IncidentSettings>
        </div>
      </b-tab>


      <b-tab :title="$t('maintenance.incidents.incident_categories.tab.relations')">
        <b-tabs class="menu-smaller">

          <b-tab :title="$t('maintenance.incidents.incident_categories.tab.risk_scenarios')" class="mt-3">
            <RiskScenariosTable :object="incident" @updated="updateIncident"></RiskScenariosTable>
          </b-tab>

          <b-tab :title="$t('maintenance.incidents.incident_categories.tab.systems')" class="mt-3">
            <SystemsTable :object="incident" @updated="updateIncident"></SystemsTable>
          </b-tab>

        </b-tabs>
      </b-tab>


      <b-tab :title="$t('maintenance.incidents.incident_categories.tab.responsibles')">
        <div class="card mt-3">
          <Responsibles :object="incident" @updated="updateIncident"></Responsibles>
        </div>
        <!-- <div class="card mt-3">
          <Escalation :object="incident" @updated="updateIncident"></Escalation>
        </div> -->
      </b-tab>


      <b-tab :title="$t('maintenance.incidents.incident_categories.tab.schedule')">
        <div class="card mt-3">
          <ScheduleTable :object="incident" @updated="updateIncident"></ScheduleTable>
        </div>
      </b-tab>


      <b-tab :title="$t('maintenance.incidents.incident_categories.tab.questions')">
        <div class="card mt-3">

          <div class="card scope mt-3">
            <div class="card-header">
              <div class="float-left w-100">
                <span class="h5" qid="integrity-check-table-title">
                  {{ $t('maintenance.incidents.default_questions.title') }}
                </span>
                <span v-if="!showForm && isGranted([permissions.INCIDENT_CATEGORY_EDIT, permissions.INCIDENT_CATEGORY_EDIT_OWN], incident.created_by) && (!getClient.parent || (getClient.parent && incident.partition))"
                      class="float-right btn btn-success"
                      qid="integrity-edit-button"
                      @click="showFormFunction"
                >
                    <font-awesome-icon icon="pen" /> {{ $t('system.edit') }}
                  </span>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-sm-2 card-menu">
                <div class="card-body text-dark pt-0 pb-0">
                  <p class="mt-2">
                    {{ $t('maintenance.incidents.default_questions.title_label') }}
                  </p>
                </div>
              </div>
              <div class="col-sm-10">
                <div class="card-body pt-0 pb-0">
                  <div v-if="showForm" class="mb-5"></div>
                  <div v-if="!showForm">
                    <p class="mt-2">
                      <span>
                        <span class="badge-pill badge-success mr-1">
                          <font-awesome-icon icon="check" size="xs"/>
                        </span>
                        <span class="text-muted">
                          {{ $t('maintenance.incidents.default_questions.mandatory_label') }}
                        </span>
                      </span>
                    </p>
                    <br>
                  </div>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-sm-2 card-menu">
                <div class="card-body text-dark pt-0 pb-0">
                  <p class="mt-2">
                    {{ $t('maintenance.incidents.default_questions.description_label') }}
                  </p>
                </div>
              </div>
              <div class="col-sm-10">
                <div class="card-body pt-0 pb-0">
                  <div v-if="showForm" class="mw-500">
                    <multiselect
                        v-model="addDescription"
                        :options="allowTypes"
                        :placeholder="$t('maintenance.questions.create.add_description_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="create-p-form-pg"
                    ></multiselect>
                    <br>
                  </div>

                  <div v-if="!showForm">
                    <p class="mt-2" v-if="incident">
                      <span>
                        <span v-if="incident.add_description && (incident.add_description == 'Optional' || incident.add_description == 'Mandatory')">
                          <span class="badge-pill badge-success mr-1">
                            <font-awesome-icon icon="check" size="xs"/>
                          </span>
                          {{ $t('maintenance.questions.type.' + $options.filters.slugify(incident.add_description)) }}
                        </span>
                        <span v-else>
                          <span class="badge-pill badge-danger mr-1">
                            <font-awesome-icon icon="times" size="xs"/>
                          </span>
                          {{ $t('maintenance.questions.type.no') }}
                        </span>
                      </span>
                    </p>
                    <br>
                  </div>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-sm-2 card-menu">
                <div class="card-body text-dark pt-0">
                  <p class="mt-2">
                    {{ $t('maintenance.incidents.default_questions.attachments_label') }}
                  </p>
                </div>
              </div>
              <div class="col-sm-10">
                <div class="card-body pt-0">
                  <div v-if="showForm" class="mw-500 mb-4">
                    <multiselect
                        v-model="addAttachments"
                        :options="allowTypes"
                        :placeholder="$t('maintenance.questions.create.add_description_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="create-p-form-pg"
                    ></multiselect>
                    <br>
                    <div class="text-left">
                      <b-button class="mt-3"
                                variant="secondary"
                                @click="cancelFormFunction"
                                qid="integrity-edit-cancel-button"
                      >
                        {{ $t('activities.create.cancel') }}
                      </b-button>
                      <b-button class="mt-3 ml-3"
                                variant="success"
                                @click="formSubmit"
                                qid="integrity-edit-submit-button"
                      >
                        {{ $t('activities.create.submit') }}
                      </b-button>
                    </div>
                  </div>

                  <div v-if="!showForm">
                    <p class="mt-2" v-if="incident">
                      <span>
                        <span v-if="incident.add_attachments && (incident.add_attachments == 'Optional' || incident.add_attachments == 'Mandatory')">
                          <span class="badge-pill badge-success mr-1">
                            <font-awesome-icon icon="check" size="xs"/>
                          </span>
                          {{ $t('maintenance.questions.type.' + $options.filters.slugify(incident.add_attachments)) }}
                        </span>
                        <span v-else>
                          <span class="badge-pill badge-danger mr-1">
                            <font-awesome-icon icon="times" size="xs"/>
                          </span>
                          {{ $t('maintenance.questions.type.no') }}
                        </span>
                      </span>
                    </p>
                    <br>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

        <div>
          <QuestionsTable :object="incident"></QuestionsTable>
        </div>

      </b-tab>


      <b-tab :title="$t('maintenance.incidents.incident_categories.tab.project_tasks')">
        <div>
          <TasksTable :object="incident"></TasksTable>
        </div>
      </b-tab>

      <!-- History tab -->
      <b-tab :title="$t('activities.tab.history')" class="mt-3" @click="historyTabClicked">
        <div v-if="showHistoryTab">
          <IncidentCategoryHistory :object="incident"></IncidentCategoryHistory>
        </div>
      </b-tab>

    </b-tabs>


    <!-- Edit incident category modal template -->
    <b-modal ref="edit-category" hide-footer>
      <div class="d-block text-center">
        <h4 qid="update-p-title">
          {{ $t('maintenance.incidents.incident_categories.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editPFormSubmit" qid="edit-p-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-p-name-label">
              {{ $t('maintenance.incidents.incident_categories.create.name_label') }}
            </label>
            <span class="text-red">*</span>
            <b-form-input
              qid="edit-p-form-name"
              type="text"
              v-model="pForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.incidents.incident_categories.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-p-implementation-status-label">
              {{ $t('maintenance.incidents.incident_categories.create.type_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="selectedType"
                :options="types"
                track-by="value"
                :placeholder="$t('maintenance.incidents.incident_categories.create.type_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="edit-p-form-implementation-status"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditPModal"
                    qid="edit-p-cancel-button"
          >
            {{ $t('maintenance.measures.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.measures.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Delete Policy confirm modal template -->
    <b-modal ref="delete-measure" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-p-title">
          {{ $t('maintenance.measures.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.measures.delete.description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.measures.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="delete-p-cancel-button"
        >
          {{ $t('maintenance.measures.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteP(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-p-submit-button"
                  v-if="isGranted([permissions.INCIDENT_CATEGORY_DELETE, permissions.INCIDENT_CATEGORY_DELETE_OWN], itemToDelete.created_by)"
        >
          {{ $t('maintenance.measures.delete.submit') }}
        </b-button>
      </div>
    </b-modal>

    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

  </div>
</template>

<script>
import {initialsAvatarUrl} from '@/util/userAvatar.js';
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js'
import Validations from '@/views/Validations/Validations.vue';
import Avatar from '@/components/Avatar.vue';
import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
import ThirdPartiesTable from '@/views/Measures/ThirdPartiesTable.vue';
import GenericControlsTable from '@/views/Measures/GenericControlsTable.vue';
import IncidentCategoryHistory from '@/views/Incidents/IncidentCategoryHistory.vue';
import DescriptionBlock from '@/views/Incidents/DescriptionBlock.vue';
import IncidentSettings from '@/views/Incidents/IncidentSettings.vue';
import RiskScenariosTable from '@/views/Incidents/RiskScenariosTable.vue';
import SystemsTable from '@/views/Incidents/SystemsTable.vue';
import Responsibles from '@/views/Incidents/Responsibles.vue';
import QuestionsTable from '@/views/Incidents/QuestionsTable.vue';
import TasksTable from '@/views/Incidents/TasksTable.vue';
import Escalation from '@/views/Incidents/Escalation.vue';
import ScheduleTable from '@/views/Incidents/ScheduleTable.vue';
import GuideButton from '@/components/guide/GuideButton.vue';


export default {
  name: 'IncidentCategoryView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('maintenance.title'),
          to: '/maintenance'
        },
        {
          text: this.$t('maintenance.incidents.incident_categories.title'),
          to: '/maintenance/incident-categories'
        }
      ],
      defaultQuestionForm: {
        add_description: '',
        add_attachments: ''
      },
      incident: {},
      showLinkInput: false,
      showSingleLinkLabel: true,
      inputLink: '',
      inputLinkName: '',
      itemToDelete: {},
      pForm: {
        name: '',
        type: []
      },
      allowTypes: [
        { name: this.$t('maintenance.questions.type.no'), value: 'No' },
        { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
        { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
      ],
      types: [
        { name: this.$t('maintenance.incidents.incident_categories.type.incident'), value: 'incident' },
        { name: this.$t('maintenance.incidents.incident_categories.type.service_request'), value: 'service_request' },
      ],
      error: '',
      attachmentError: '',
      categoryItems: [],
      categoryInput: '',
      selectedCategory: [],
      selectedType: [],
      responseType: [],
      selectedOptions: [],
      inputOption: '',
      positiveAnswers: [],
      negativeAnswers: [],
      allAnswers: [],
      allAnswersCopy: [],
      showInput: true,
      buttonDisabled: false,
      selectedFile: {},
      selectedLink: {},
      showDeleteAttachmentModal: false,
      showDeleteLinkModal: false,
      myGuides: [],
      showActivityTab: false,
      showControlTab: false,
      showSystemTab: false,
      showThirdPartyTab: false,
      showHistoryTab: false,

      showForm: false,
      addDescription: [],
      addAttachments: []
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug !== oldValue.slug) {
        this.goToList()
      } else {
        this.loadContent();
      }
    },
    selectedOptions: function (value) {
      let self = this
      this.allAnswers = value
      this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      _.forEach(this.positiveAnswers, function (answer) {
        self.handleAvailableAnswers(answer)
      })
      _.forEach(this.negativeAnswers, function (answer) {
        self.handleAvailableAnswers(answer)
      })
    }
  },
  components: {
    Validations,
    Avatar,
    ConfirmRemoveAttachment,
    ThirdPartiesTable,
    GenericControlsTable,
    IncidentCategoryHistory,
    DescriptionBlock,
    IncidentSettings,
    GuideButton,
    RiskScenariosTable,
    SystemsTable,
    Responsibles,
    ScheduleTable,
    QuestionsTable,
    TasksTable,
    Escalation
  },
  methods: {
    goToList() {
      this.$router.push('/maintenance/incident-categories')
    },
    valueSelected(value) {
      if (value.value != 'dropdown') {
        this.selectedOptions = []
        this.responseType = []
      }
    },
    updateIncident() {
      this.breadcrumbItems.pop();
      this.loadContent();
    },
    showFormFunction() {
      let self = this;

      this.addDescription = []
      if (this.incident.add_description) {
        this.addDescription = _.find(this.allowTypes, function(item) {
          return item.value === self.incident.add_description;
        });
      } else {
        this.addDescription = this.allowTypes[0]
      }

      this.addAttachments = []
      if (this.incident.add_attachments) {
        this.addAttachments = _.find(this.allowTypes, function(item) {
          return item.value === self.incident.add_attachments;
        });
      } else {
        this.addAttachments = this.allowTypes[0]
      }

      this.showForm = true;
    },
    cancelFormFunction() {
      this.addDescription = []
      this.addAttachments = []
      this.defaultQuestionForm.add_description = ''
      this.defaultQuestionForm.add_attachments = ''
      this.showForm = false;
    },
    formSubmit() {
      let self = this;

      if (this.addDescription && this.addDescription.value) {
        this.defaultQuestionForm.add_description = this.addDescription.value
      }

      if (this.addAttachments && this.addAttachments.value) {
        this.defaultQuestionForm.add_attachments = this.addAttachments.value
      }

      piincHttp.put('incident-categories/' + this.$route.params.slug, this.defaultQuestionForm).then(function(response) {
        self.breadcrumbItems.pop();
        self.loadContent()
        self.buttonDisabled = false;
        self.cancelFormFunction();
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.defaultQuestionForm.error = error.data.message;
        }
      })
    },
    resetFile() {
      let imagefile = document.querySelector('#file');
      imagefile.value = '';
    },
    activityTabClicked() {
      this.showActivityTab = true;
      this.showSystemTab = false;
      this.showThirdPartyTab = false;
      this.showControlTab = false;
    },
    systemTabClicked() {
      this.showActivityTab = false;
      this.showSystemTab = true;
      this.showThirdPartyTab = false;
      this.showControlTab = false;
    },
    thirdPartyTabClicked() {
      this.showActivityTab = false;
      this.showSystemTab = false;
      this.showThirdPartyTab = true;
      this.showControlTab = false;
    },
    controlTabClicked() {
      this.showActivityTab = false;
      this.showSystemTab = false;
      this.showThirdPartyTab = false;
      this.showControlTab = true;
    },
    handleType(value) {
      this.positiveAnswers = []
      this.negativeAnswers = []
      if (value && value.value == 'Select') {
        this.allAnswers = this.selectedOptions
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      } else {
        this.allAnswers = this.yesNoOptions
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      }
    },
    handleOption(evt) {
      evt.preventDefault();
      // If there's a link in input, add it to links array
      if (this.inputOption !== '') {
        this.selectedOptions.push(this.inputOption)
        // Reset link input form
        this.inputOption = ''
      }
      this.showInput = false;
    },
    removeOptionItem(index, item) {
      let positiveIndex = _.findIndex(this.positiveAnswers, function(answer) { return answer == item })
      let negativeIndex = _.findIndex(this.negativeAnswers, function(answer) { return answer == item })

      this.selectedOptions.splice(index, 1);

      if (!this.selectedOptions.length) {
        this.showInput = true;
      }

      if (positiveIndex != -1) {
        this.positiveAnswers.splice(positiveIndex, 1)
      }
      if (negativeIndex != -1) {
        this.negativeAnswers.splice(negativeIndex, 1)
      }
    },
    handleAvailableAnswers(answer) {
      let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
      if (index != -1) {
        this.allAnswersCopy.splice(index, 1)
      }
    },
    expandAvailableAnswers(answer) {
      let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
      if (index == -1) {
        this.allAnswersCopy.push(answer)
      }
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Incident' && object.enabled
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Incident',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    loadContent() {
      let self = this;
      piincHttp.get('incident-categories/' + this.$route.params.slug, { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.incident = response.data;
        // Push content name in breadcrumb array
        self.breadcrumbItems.push({text: self.incident.name, active: true});
      }, function() {});
    },
    openDeleteAttachmentModal(object) {
      this.selectedFile = object
      this.showDeleteAttachmentModal = true
    },
    closeDeleteAttachmentModal () {
      this.selectedFile = {}
      this.showDeleteAttachmentModal = false;
      // Remove last item in breadcrumbs, because it will be added again on load content
      this.breadcrumbItems.pop();
      this.loadContent();
    },
    openDeleteLinkModal(object) {
      this.selectedLink = object
      this.showDeleteLinkModal = true
    },
    closeDeleteLinkModal () {
      this.selectedLink = {}
      this.showDeleteLinkModal = false;
      // Remove last item in breadcrumbs, because it will be added again on load content
      this.breadcrumbItems.pop();
      this.loadContent();
    },
    handleCategoryInput(input) {
      this.categoryInput = input;
    },
    handleLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLink.startsWith('http')) {
        this.inputLink = 'http://' + this.inputLink
      }

      formData.append("url", this.inputLink);
      formData.append("name", this.inputLinkName);
      formData.append("model_type", this.incident.who_am_i);
      formData.append("model_id", this.incident.id);

      piincHttp.post('links', formData).then(function() {
        // Remove last item in breadcrumbs, because it will be added again on load content
        self.breadcrumbItems.pop();
        self.$toastr('success', self.$t('maintenance.measures.link_add_success'))
        self.loadContent()
        self.inputLink = ''
        self.inputLinkName = ''
        self.showLinkInput = false
      }, function() {})
    },
    downloadMedia(object){
      piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = object.file_name;

        link.click();
        link.remove()
        window.URL.revokeObjectURL(url);
      }, function() {});
    },
    onFileChange(file) {
      let files = file.target.files;
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      for (var i = 0; i < files.length; i++) {
        // Equal to 10 MB
        if (files[i].size > 10485760) {
          sizeError = true;
        }
        formData.append('document[]', files[i]);
      }

      formData.append("name", "documents");
      formData.append("model_type", this.incident.who_am_i);
      formData.append("model_id", this.incident.id);

      if (sizeError) {
        this.attachmentError = this.$t('system.file_size')
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function() {
          // Remove last item in breadcrumbs, because it will be added again on load content
          self.breadcrumbItems.pop();
          self.$toastr('success', self.$t('maintenance.measures.media_add_success'))
          self.attachmentError = ''
          self.loadContent()
        }, function(error) {
          self.attachmentError = error.data.message;
          if (error.data.errors['document.0']) {
            self.attachmentError += ' ' + error.data.errors['document.0'][0]
          }
        })
      }
    },
    getUserAvatar(user){
      if (user && user.avatar) {
        return user.avatar;
      } else {
        return initialsAvatarUrl(user);
      }
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-measure'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-measure'].hide()
    },
    confirmDeleteP(object) {
      let self = this;
      piincHttp.delete('measures/' + object.slug).then(function() {
        self.hideConfirmDeleteModal();
        self.goToList();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('maintenance.measures.delete.success'))
      }, function() {});
    },
    showEditPModal(object) {
      let self = this;

      self.selectedType = [];
      this.error = ''

      if (object.type) {
        this.selectedType = _.find(this.types, function(item) {
          return item.value === object.type;
        });
      }

      this.pForm.slug = object.slug;
      this.pForm.name = object.name;
      this.$refs['edit-category'].show()
    },
    hideEditPModal() {
      this.error = ''
      this.$refs['edit-category'].hide()
    },
    editPFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      if (this.selectedType && this.selectedType.value) {
        this.pForm.type = this.selectedType.value
      }

      this.pForm.client = this.getClient.slug;

      if (this.selectedType && this.selectedType.value) {
        piincHttp.put('incident-categories/' + this.pForm.slug, this.pForm).then(function(response) {
          self.hideEditPModal();
          self.buttonDisabled = false;
          // If slug is not changed, just reload content
          if (response.data.slug === self.incident.slug) {
            // Remove last item in breadcrumbs, because it will be added again on load content
            self.breadcrumbItems.pop();
            self.loadContent();
          } else {
            // If slug changed, reload state with new param
            self.$router.push({ name: 'maintenance.incident_categories.view', params: { slug: response.data.slug }})
          }
          self.$toastr('success', self.$t('maintenance.incidents.incident_categories.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.buttonDisabled = false;
        this.error = this.$t('maintenance.incidents.incident_categories.create.type_error')
      }
    },
    historyTabClicked() {
      this.showActivityTab = false;
      this.showSystemTab = false;
      this.showThirdPartyTab = false;
      this.showControlTab = false;
      this.showHistoryTab = true;
    }
  },
  created () {
    if (this.getClient && this.getClient.slug) {
      this.loadContent();
    }
    this.loadGuides('update_basic_info');
  }
}
</script>
